import React from "react";
import {IListViewCreateDependedDocumentAction} from "../IListViewCreateDependedDocumentAction";
import {IListViewCreateMoreActions} from "../IListViewCreateMoreAction";

interface IProps {
    children?: React.ReactNode;
    onCreateNewClick?: () => void;
    onCloneClick?: () => void;
    onEditClick?: () => void;
    onShowTransactionsPage?: () => void;
    onShowPopup?: () => void;
    onDeleteClick?: () => void;
    onPostClick?: () => void;
    onCancelClick?: () => void;
    handleCreateDocumentActionPopupButtonClick?: () => void;
    handleCreateDocumentAction?: () => void;
    setCreateDocumentActionVisible?: (visible: boolean) => void;
    createDocumentActionVisible?: boolean;
    createDocumentActions?: IListViewCreateDependedDocumentAction[];
    createMoreActions?: IListViewCreateMoreActions[];
    handleClick?: () => void;
    handleComponentRefresh?: () => void;
    handleOpenMoreActions?: () => void;
    setCreateMoreActionsVisible?: (visible: boolean) => void;
    createMoreActionsVisible?: boolean;
    disabled?: boolean;
    handleOpenHierarchy?: () => void;
}

export const DocumentListViewToolbar = ({
                                            children,
                                            onPostClick,
                                            onCancelClick,
                                            onDeleteClick,
                                            onShowPopup,
                                            onCreateNewClick,
                                            onShowTransactionsPage,
                                            onEditClick,
                                            onCloneClick,
                                            setCreateDocumentActionVisible,
                                            handleCreateDocumentAction,
                                            createMoreActions,
                                            createDocumentActions,
                                            createDocumentActionVisible,
                                            handleCreateDocumentActionPopupButtonClick,
                                            handleClick,
                                            handleComponentRefresh,
                                            handleOpenMoreActions,
                                            setCreateMoreActionsVisible,
                                            createMoreActionsVisible,
                                            disabled,
                                            handleOpenHierarchy
                                        }: IProps) => {
    const arrayChildren = React.Children.toArray(children);

    return (
        <>
            <div className={"d-flex flex-wrap"}>
                {arrayChildren &&
                    arrayChildren.map((child: any, index) => {
                        return (
                            <React.Fragment key={index}>
                                {React.cloneElement(child, {
                                    onCloneClick: onCloneClick,
                                    onCreateNewClick: onCreateNewClick,
                                    onEditClick: onEditClick,
                                    onShowTransactionsPage: onShowTransactionsPage,
                                    onShowPopup: onShowPopup,
                                    onDeleteClick: onDeleteClick,
                                    onPostClick: onPostClick,
                                    onCancelClick: onCancelClick,
                                    handleCreateDocumentActionPopupButtonClick: handleCreateDocumentActionPopupButtonClick,
                                    handleCreateDocumentAction: handleCreateDocumentAction,
                                    createDocumentActions: createDocumentActions,
                                    createMoreActions: createMoreActions,
                                    handleClick: handleClick,
                                    handleComponentRefresh: handleComponentRefresh,
                                    handleOpenMoreActions: handleOpenMoreActions,
                                    setCreateMoreActionsVisible: setCreateMoreActionsVisible,
                                    createMoreActionsVisible: createMoreActionsVisible,
                                    disabled: disabled,
                                    handleOpenHierarchy: handleOpenHierarchy,
                                })}
                            </React.Fragment>
                        );
                    })}
            </div>
        </>
    );
};
